export default __webpack_public_path__ + "d49258ccf73a7099cd82d4851d944cc7.otf";